// src/ThemeToggle.js
import React from 'react';
import { useTheme } from './ThemeContext';
import { Sun, Moon } from 'lucide-react';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button 
      className="theme-toggle-dropdown-item" 
      onClick={toggleTheme}
      aria-label="Toggle theme"
    >
      {theme === 'light' ? (
        <>
          <Moon className="theme-icon" size={16} />
          <span>Dark Mode</span>
        </>
      ) : (
        <>
          <Sun className="theme-icon" size={16} />
          <span>Light Mode</span>
        </>
      )}
    </button>
  );
};

export default ThemeToggle;